export const isNumber=(value) =>{
  return typeof value === 'number' && !isNaN(value);
}
export const percentageCalculation = (percentage,value) => percentage * value / 100 